import ParcelTemplate from '~/types/ParcelTemplate';
import { TrackingReference } from '~/utils/TrackingHelper/types';
import { ActionKeys } from './constants';

export interface DefaultPackageUnitsPayload {
  defaultWeightUnit: string;
  defaultDistanceUnit: string;
}

export interface DefaultPackageUnitsErrorPayload {
  errorMessage: string;
}

export function fetchDefaultPackageUnits() {
  return <const>{
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS,
  };
}

export function fetchDefaultPackageUnitsSuccess(payload: DefaultPackageUnitsPayload) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS,
  };
}

export function fetchDefaultPackageUnitsError(payload: DefaultPackageUnitsErrorPayload) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_ERROR,
  };
}

export function updateDefaultPackageUnits(payload: DefaultPackageUnitsPayload) {
  return <const>{
    payload,
    type: ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS,
  };
}

export function updateDefaultPackageUnitsSuccess(payload: DefaultPackageUnitsPayload) {
  return <const>{
    payload,
    type: ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS_SUCCESS,
  };
}

export function updateDefaultPackageUnitsError(payload: DefaultPackageUnitsErrorPayload) {
  return <const>{
    payload,
    type: ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS_ERROR,
  };
}

export function savePackageTemplate(
  formData: ParcelTemplate,
  applyNewParcelTemplateOnParcelForm: boolean,
  trackingReference: TrackingReference,
) {
  return <const>{
    payload: {
      formData,
      applyNewParcelTemplateOnParcelForm,
      trackingReference,
    },
    type: ActionKeys.SAVE_PACKAGE_TEMPLATE,
  };
}

export function savePackageTemplateSuccess(
  parcelTemplate: ParcelTemplate,
  trackingReference: TrackingReference,
  applyNewParcelTemplateOnParcelForm?: boolean,
) {
  return <const>{
    payload: {
      parcelTemplate,
      trackingReference,
      applyNewParcelTemplateOnParcelForm,
    },
    type: ActionKeys.SAVE_PACKAGE_TEMPLATE_SUCCESS,
  };
}

export function savePackageTemplateError(parcelTemplate: ParcelTemplate) {
  return <const>{
    payload: {
      parcelTemplate,
    },
    type: ActionKeys.SAVE_PACKAGE_TEMPLATE_ERROR,
  };
}

export function deletePackageTemplate(objectId: string, trackingReference: TrackingReference) {
  return <const>{
    type: ActionKeys.DELETE_PACKAGE_TEMPLATE,
    payload: {
      objectId,
      trackingReference,
    },
  };
}

export function deletePackageTemplateSuccess(objectId: string) {
  return <const>{
    type: ActionKeys.DELETE_PACKAGE_TEMPLATE_SUCCESS,
    payload: {
      objectId,
    },
  };
}

export function deletePackageTemplateError(errorMessage?: string) {
  return <const>{
    type: ActionKeys.DELETE_PACKAGE_TEMPLATE_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export type PackagesActions =
  | ReturnType<typeof fetchDefaultPackageUnits>
  | ReturnType<typeof fetchDefaultPackageUnitsSuccess>
  | ReturnType<typeof fetchDefaultPackageUnitsError>
  | ReturnType<typeof updateDefaultPackageUnits>
  | ReturnType<typeof updateDefaultPackageUnitsSuccess>
  | ReturnType<typeof updateDefaultPackageUnitsError>
  | ReturnType<typeof savePackageTemplate>
  | ReturnType<typeof savePackageTemplateSuccess>
  | ReturnType<typeof savePackageTemplateError>
  | ReturnType<typeof deletePackageTemplate>
  | ReturnType<typeof deletePackageTemplateSuccess>
  | ReturnType<typeof deletePackageTemplateError>;
